import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
// import { Link } from 'react-router-dom';
import classNames from 'classnames';
import messages from './messages';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(1, 0, 1, 0)
    },
    [theme.breakpoints.down('sm')]: {
      margin: 0
    },
    position: 'relative',
    width: '100%',
    textAlign: 'center'
  },
  buttonLabel: {
    fontSize: '1rem'
  },
  buttonLabelLarge: {
    fontSize: 18
  },
  buttonLarge: {
    minHeight: 56
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700]
    }
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  successTextTypography: {
    textAlign: 'center'
  },
  rounded: {
    borderRadius: theme.spacing(4)
  },
  elevation: {
    boxShadow: '0px 0px 20px #00000029'
  },
  dense: {
    padding: theme.spacing(0.75, 0.5)
  },
  outlined: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.text.primary}`,
    '&:hover': {
      border: `1px solid ${theme.palette.text.primary}`,
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText
    },
    '&:focus': {
      border: `1px solid ${theme.palette.text.primary}`,
      backgroundColor: 'transparent',
      color: theme.palette.text.primary
    }
  }
}));

const ContentWrapper = ({
  disableWrapper,
  wrapperClass,
  success,
  successLabel,
  loading,
  children
}) => {
  const classes = useStyles();

  return disableWrapper ? (
    children
  ) : (
    <div className={classNames(wrapperClass, classes.wrapper)}>
      {success ? (
        <Typography className={classes.successTextTypography}>
          {successLabel || messages.successText}
        </Typography>
      ) : (
        children
      )}
      {loading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </div>
  );
};

const CarwizButton = ({
  label,
  successLabel,
  loading,
  success,
  disabled,
  rounded,
  color = 'primary',
  variant = 'contained',
  fullWidth = true,
  onClick,
  wrapperClass,
  labelClass,
  disabledClass,
  disableWrapper,
  addElevation = true,
  dense,
  large,
  trackingClassName,
  onMouseEnter = () => {},
  children,
  rootClassName,
  ...props
}) => {
  const classes = useStyles();
  return (
    <ContentWrapper
      disableWrapper={disableWrapper}
      wrapperClass={wrapperClass}
      success={success}
      successLabel={successLabel}
      loading={loading}
    >
      <Button
        classes={{
          disabled: disabledClass,
          label: classNames(
            labelClass ||
              (large ? classes.buttonLabelLarge : classes.buttonLabel)
          ),
          root: classNames(
            {
              [classes.buttonSuccess]: success,
              [classes.rounded]: rounded,
              [classes.elevation]: addElevation,
              [classes.dense]: dense,
              [classes.outlined]: variant === 'outlined',
              [classes.buttonLarge]: large,
              [trackingClassName]: Boolean(trackingClassName)
            },
            rootClassName
          )
        }}
        fullWidth={fullWidth}
        variant={variant}
        disabled={disabled || loading}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        color={color}
        disableElevation
        {...props}
        aria-busy={loading ? 'true' : 'false'}
      >
        {label || children || messages.submitText}
      </Button>
    </ContentWrapper>
  );
};

CarwizButton.defaultProps = {
  successLabel: messages.successText,
  loading: false,
  success: false
};

export default CarwizButton;
